import React, { Fragment, PureComponent } from "react";
import PropTypes from "prop-types";

import Button from "../../Common/Button";

export default class PanelMobileContextMenuButtons extends PureComponent {
  static propTypes = {
    actions: PropTypes.array.isRequired
  };

  render() {
    return (
      <div className="panel-header__menu-buttons">
        {this.props.actions.map(action => (
          <Fragment key={action.label}>
            <Button
              key={action.label}
              className="panel-header__menu-button"
              labelClass="button__filter-label"
              iconClassName="button__filter-icon"
              onClick={action.onClick}
              label={action.label}
              icon={action.icon}
            />
            <hr className="panel-header__menu-line" />
          </Fragment>
        ))}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Layout/Panel/PanelMobileContextMenuButtons.js